import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/layout/Home.vue'
import login from '../components/login/login.vue'
import PatientAccountReportEnd from '../components/main/accountManage/PatientAccount/PatientAccountReportEnd.vue'
Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      children: [{
          path: '/changePassword',
          component: () =>
            import('../components/main/public/changePassword.vue')
        },
        {
          path: '/OverviewBasicData',
          component: () =>
            import('../components/main/consoleDesk/OverviewBasicData.vue'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/OverviewBasicDetail',
          component: () =>
            import('../components/main/consoleDesk/OverviewBasicDetail.vue')
        },
        {
          path: '/RegionalDataStatisticsDetail',
          component: () =>
            import('../components/main/consoleDesk/RegionalDataStatisticsDetail.vue')
        },
        {
          path: '/RegionalDataStatistics',
          component: () =>
            import('../components/main/consoleDesk/RegionalDataStatistics.vue')
        },
        {
          path: '/orzInformationManage',
          component: () =>
            import('../components/main/orzManagement/orzInformationManage.vue')
        },
        {
          path: '/orzCreate',
          component: () =>
            import('../components/main/orzManagement/orzCreate.vue')
        },
        {
          path: '/orzDetails',
          component: () =>
            import('../components/main/orzManagement/orzDetails.vue')
        },
        {
          path: '/OrzAccountList',
          component: () =>
            import('../components/main/accountManage/OrzAccount/OrzAccountList.vue')
        },
        {
          path: '/OrzAccountCreate',
          component: () =>
            import('../components/main/accountManage/OrzAccount/OrzAccountCreate.vue')
        },
        {
          path: '/OrzAccountDetails',
          component: () =>
            import('../components/main/accountManage/OrzAccount/OrzAccountDetails.vue')
        },
        {
          path: '/OrzAccountReset',
          component: () =>
            import('../components/main/accountManage/OrzAccount/OrzAccountReset.vue')
        },
        {
          path: '/PatientAccountList',
          component: () =>
            import('../components/main/accountManage/PatientAccount/PatientAccountList.vue')
        },
        {
          path: '/CNHTransManage',
          component: () =>
            import('../components/main/deviceManage/CNHTransManage/CNHTransManage.vue')
        },
        {
          path: '/DataRecManage',
          component: () =>
            import('../components/main/deviceManage/DataRecManage/DataRecManage.vue')
        },
        {
          path: '/DataRecManageKey',
          component: () =>
            import('../components/main/deviceManage/DataRecManage/DataRecManageKey.vue')
        },
        {
          path: '/HospitalTransManage',
          component: () =>
            import('../components/main/deviceManage/HospitalTransManage/HospitalTransManage.vue')
        },
        {
          path: '/HospitalTransManageKey',
          component: () =>
            import('../components/main/deviceManage/HospitalTransManage/HospitalTransManageKey.vue')
        },
        {
          path: '/PatientAccountDetails',
          component: () =>
            import('../components/main/accountManage/PatientAccount/PatientAccountDetails.vue')
        },
        {
          path: '/CNHTransCreate',
          component: () =>
            import('../components/main/deviceManage/CNHTransManage/CNHTransCreate.vue')
        },
        {
          path: '/CNHTransDetails',
          component: () =>
            import('../components/main/deviceManage/CNHTransManage/CNHTransDetails.vue')
        },
        {
          path: '/DataRecCreat',
          component: () =>
            import('../components/main/deviceManage/DataRecManage/DataRecCreat.vue')
        },
        {
          path: '/DataRecDetails',
          name: 'DataRecDetails',
          component: () =>
            import('../components/main/deviceManage/DataRecManage/DataRecDetails.vue')
        },
        {
          path: '/DataRecDetailsDel',
          name: 'DataRecDetailsDel',
          component: () =>
            import('../components/main/deviceManage/DataRecManage/DataRecDetailsDel.vue')
        },
        {
          path: '/HospitalTransCreat',
          component: () =>
            import('../components/main/deviceManage/HospitalTransManage/HospitalTransCreat.vue')
        },
        {
          path: '/HospitalTransDetails',
          name: 'HospitalTransDetails',
          component: () =>
            import('../components/main/deviceManage/HospitalTransManage/HospitalTransDetails.vue')
        },
        {
          path: '/HospitalTransDetailsDel',
          name: 'HospitalTransDetailsDel',
          component: () =>
            import('../components/main/deviceManage/HospitalTransManage/HospitalTransDetailsDel.vue')
        },
        {
          path: '/PatientAccountReport',
          name: 'PatientAccountReport',
          component: () =>
            import('../components/main/accountManage/PatientAccount/PatientAccountReport.vue')
        },
        {
          path: '/LogSetting',
          name: 'LogSetting',
          component: () =>
            import('../components/main/log/LogSetting.vue')
        },
        {
          path: '/LoginLog',
          name: 'LoginLog',
          component: () =>
            import('../components/main/log/LoginLog.vue')
        },
        {
          path: '/OperationLog',
          name: 'OperationLog',
          component: () =>
            import('../components/main/log/OperationLog.vue')
        },
        {
          path: '/SystemAccountManagement',
          name: 'SystemAccountManagement',
          component: () =>
            import('../components/main/SystemAccountManagement.vue')
        },
        {
          path: '/SystemAccountCreate',
          name: 'SystemAccountCreate',
          component: () =>
            import('../components/main/SystemAccountCreate.vue')
        },
        {
          path: '/SystemAccountDetails',
          name: 'SystemAccountDetails',
          component: () =>
            import('../components/main/SystemAccountDetails.vue')
        },
        {
          path: '/SystemAccountReset',
          name: 'SystemAccountReset',
          component: () =>
            import('../components/main/SystemAccountReset.vue')
        },
        {
          path: '/accounts',
          name: 'accounts',
          component: () =>
          import('../components/main/public/accounts.vue')
        }
      ]
    },
    {
      path: '/PatientAccountReportEnd',
      name: 'PatientAccountReportEnd',
      component: PatientAccountReportEnd
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let username = sessionStorage.getItem('username')
    if (username === null || username === '') {
      debugger
      next('/login')
    } else {
      next()
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js